import tireSidewall from '../../../Assets/technical_info/tire_sidewall_markings.png'
import speedChart from '../../../Assets/technical_info/speed_rating_index_chart.png'
import loadChart from '../../../Assets/technical_info/tire_load_index_chart.png'

const TechnicalLV2 = () => {
    return (
        <div>
			<p><span style={ { fontSize: "24px" } }><strong>Apzīmējumi</strong></span></p>

			<p><img alt="" src={tireSidewall} style={ { width: "min(100%, 400px)", height: "auto", display: "block", margin: "auto"} } /></p>
						
			<p>&nbsp;</p>

			<ul>
				<li><strong>"205"</strong> - Riepas platums, mm</li>
				<li><strong>"55"</strong> - Riepas profila attiecība, % (riepas sānu malas augstums ir 55% no riepas platuma)</li>
				<li><strong>"R"</strong> - Radiālās riepas konstrukcijas apzīmējums</li>
				<li><strong>"16"</strong> - Diska diametrs, collās</li>
				<li><strong>"91"</strong> - Slodzes indekss (maksimālā nestspēja 615 kg uz vienu riepu)</li>
				<li><strong>"V"</strong> - Ātruma indekss (maksimāli pieļaujamais ātrums)</li>
				<li><strong>"XL"</strong> - Palielinātas kravnesības riepa (Extra Load)</li>
				<li><strong>"TUBELESS"</strong> - Bezkameru riepa ("TUBE TYPE" riepām jābūt montētām ar kameru)</li>
				<li><strong>"DOT"</strong> - ASV Transporta departamenta marķējums (Department of Transportation)</li>
				<li><strong>"2524"</strong> - Ražošanas datuma kods (25. nedēļa, 2024. gads)</li>
				<li><strong>"E4"</strong> - Marķējums, kas norāda atbilstību ECE normām</li>
				<li><strong>"0212345"</strong> - Apstiprināšanas numurs saskaņā ar attiecīgajiem ECE noteikumiem</li>
			</ul>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Riepas platums</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas platums tiek norādīts milimetros (piemēram, 205 mm). Mūsdienu vieglo automašīnu riepām platums parasti ir no 125 mm (piemēram, 125/80R12) līdz 335 mm (piemēram, 335/30R19). Platums visbiežāk palielinās ar 10 mm soli. Ņemot vērā ražošanas īpatnības, dažādu zīmolu riepām faktiskie platumi var nedaudz atšķirties. Turklāt riepas platumu ietekmē arī diska platums, uz kura riepa ir uzmontēta. Tāpēc, lai saglabātu auto ražotāja paredzētās ekspluatācijas un drošības īpašības, ieteicams ievērot ražotāja noteikto riepu un disku izmēru.</p>

			<p>&nbsp;</p>
			
			<p><span style={ { fontSize: "24px" } }><strong>Riepas augstums</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas profilu izsaka procentos no riepas platuma. Piemēram, /50 nozīmē, ka sānu malas augstums ir 50% no riepas platuma. Jo mazāks šis skaitlis, jo zemāks profils; tas ir raksturīgi sportiskākām automašīnām, piemēram, 225/45. Īpašs gadījums ir vecāks marķējums bez profila norādes, piemēram, 155R13, kur praksē tas parasti atbilst aptuveni 82% profilam. Mūsdienu apzīmējumā tas visbiežāk atbilst izmēram 155/80R13.</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Riepas uzbūve</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&bdquo;R&rdquo; nozīmē &bdquo;radiālās&rdquo; (to bieži norāda arī ar papildu uzrakstu). Tas nozīmē, ka riepas kordi ir novietoti radiāli. Līdz sešdesmitajiem gadiem plaši pieejamas bija diagonālās riepas. Uz viena auto nedrīkst uzstādīt gan radiālās, gan diagonālās riepas.</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Nodiluma indikators</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Uz riepas sāna vairākās vietās ir apzīmējums &bdquo;TWI&rdquo; (iespējami arī citi apzīmējumi). Ja seko bultas norādei, uz riepas protektora var redzēt vietas, kur protektors nav tik dziļš kā pārējā daļā. Ja protektora dziļums ir no 1 mm līdz 1,6 mm, šajās vietās protektora vairs nebūs, kas nozīmē, ka riepa ir pilnībā nolietota un satiksmē nav lietojama. Tomēr arī tik tālu riepu nevajadzētu nodzīt, jo šādi nolietota riepa krasi zaudē savas īpašības, it sevišķi uz slapja ceļa seguma.</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Pēc izmēra marķējuma var būt pievienota papildu informācija:</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>"REINFORCED"</strong> vai <strong>"EXTRA LOAD"</strong> (<strong>XL</strong>) &ndash; pastiprinātas kravnesības riepām; <strong>"M+S"</strong> &ndash; dubļiem un sniegam paredzēts marķējums. Sniegpārsliņas simbols (3PMSF), kas parasti tiek lietots kopā ar <strong>M+S</strong>, norāda, ka riepa ir testēta un atbilst noteiktiem ziemas veiktspējas kritērijiem.</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Riepu slodzes indekss</strong></span></p>

			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Slodzes indekss (LI) raksturo maksimāli pieļaujamo slodzi uz vienu riepu. Katram LI skaitlim tabulā atbilst noteikta nestspēja kilogramos. Uzstādāmajām riepām jāatbilst vismaz auto ražotāja noteiktajam LI; riepas ar lielāku LI vērtību drīkst izmantot, ja tiek ievērotas pārējās ražotāja prasības.</p>

			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Riepu slodzes indeksu tabula</strong></span></p>

			<p>&nbsp;</p>
			
			<p><img alt="" src={loadChart} style={ { width: "min(100%, 720px)", height: "auto", display: "block", margin: "auto"} } /></p>
						
			<p>&nbsp;</p>

			<p><span style={ { fontSize: "24px" } }><strong>Ātruma indeksu tabula</strong></span></p>
						
			<p>&nbsp;</p>

			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Šis burts raksturo riepas pieļaujamo maksimālo ātrumu.</p>
			
			<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sekojošiem burtiem ir attiecīgs ātrums:</p>

			<p>&nbsp;</p>

			<p><img alt="" src={speedChart} style={ { width: "min(100%, 720px)", height: "auto", display: "block", margin: "auto"} } /></p>
			
			<p>&nbsp;</p>

        </div>
    );
};

export default TechnicalLV2;


